var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Device',{attrs:{"device_guid":this.$route.params.id,"device":_vm.device},on:{"update:device":function($event){_vm.device=$event},"update":_vm.onUpdated,"reset":_vm.onResetSensor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }